// Which alarm home's banner shows (TOM-512). The alarm lifecycle's own word
// decides what needs attention (ALERT_STATE_META.needsAttention): Active,
// Silenced and AwaitingAcknowledge. An acknowledged alarm whose condition is
// still present stays on the Alarms page. The order is the Alarms page's
// (activeAlarmViews): most severe first, then the newest.

import { activeAlarmViews, type ActiveAlarmView, type AlarmStateResponse } from './alarmDisplay';

/** The alarms that need attention, most severe first; empty while the state isn't read. */
export function alarmsNeedingAttention(response: AlarmStateResponse | null): ActiveAlarmView[] {
  return response === null
    ? []
    : activeAlarmViews(response).filter((v) => v.stateMeta.needsAttention);
}
